export const getDomain = (strUrl) => {
  const url = new URL(strUrl);
  const parts = url.hostname.split(/[.]/);
  if (parts.length === 1) {
    return url.hostname;
  }
  return `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
};
